import useFeatureRoutes from "./useFeatureRoutes/useFeatureRoutes"

interface ISalesRoutes {
    bkSales: () => string
    bmSales: () => string
    mmbSales: () => string
    ppSales: () => string
}

/**
 * Hook that provides direct root routes for the sales groups: brew knowledge, brewmenu, performance platform, and market my brewery.
 * This will contain a pass-through for the features in the event that a valid context
 * is in place, it will return the feature route with the appropriate sub
 *
 * @returns An object containing functions that return the root routes for each sales group.
 */
const useSalesRoutes = (): ISalesRoutes => {
    const {
        brewKnowledgeFeatureRoute,
        brewMenuFeatureRoute,
        marketMyBreweryFeatureRoute,
        performancePlatformFeatureRoute
    } = useFeatureRoutes()

    return {
        bkSales: brewKnowledgeFeatureRoute,
        bmSales: brewMenuFeatureRoute,
        mmbSales: marketMyBreweryFeatureRoute,
        ppSales: performancePlatformFeatureRoute
    }
}

export default useSalesRoutes
